module.exports = __webpack_public_path__ + "img/yellow.38f8230c.svg";